import SubTitle from "../components/SubTitle";
import SectionTitle from "../components/SectionTitle";
import AboutIcon from "../components/icons/AboutIcon";
import { motion } from "framer-motion";
import { AboutMe, MyServices } from "../data/about-me-data";

export default function AboutSection() {
  return (
    <motion.section
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="w-full py-5 px-3 sm:px-5"
      id="about"
    >
      <SectionTitle title="about">
        <AboutIcon />
      </SectionTitle>

      <div className="flex max-[1200px]:flex-col max-[1200px]:gap-8 max-[1200px]:px-8 max-[1024px]:px-0">
        <div className="relative flex-1 pr-6 text-left text-sm after:absolute after:bottom-0 after:right-0 after:h-full after:w-px after:bg-about-divider after:content-[''] max-[1200px]:p-0 max-[1200px]:text-left max-[1200px]:after:-bottom-4 max-[1200px]:after:left-0 max-[1200px]:after:h-px max-[1200px]:after:w-full max-[1200px]:after:bg-subtitle-divider">
          {AboutMe.Description}
        </div>

        <div className="flex flex-1 flex-col justify-center gap-3 pl-6 max-[1200px]:m-0 max-[1200px]:p-0 max-[1024px]:m-auto">
          <AboutInfo label="Address" value={AboutMe.Address} />
          <AboutInfo label="Languages" value={AboutMe.Languages} />
          <AboutInfo label="Interests" value={AboutMe.Interests} />
          <AboutInfo label="Sport" value={AboutMe.Sport} />
        </div>
      </div>

      <SubTitle title="What I Build" />

      <div className="flex flex-wrap justify-center gap-8 max-[768px]:gap-6 max-[500px]:gap-4">
        {MyServices.map((service, index) => (
          <div
            key={index}
            className="flex max-w-[21rem] flex-grow flex-col gap-2 rounded-xl bg-portfolio-page p-4 max-[1024px]:w-full"
          >
            <div className="flex flex-col items-center justify-center gap-4">
              <img width="50px" src={service.Icon} alt="Service Icon" />
              <h4 className="text-sm font-semibold text-portfolio-accent">
                {service.Title}
              </h4>
            </div>
            <div className="text-xs [&_ul]:list-none [&_ul]:leading-5">
              {service.Points}
            </div>
          </div>
        ))}
      </div>
    </motion.section>
  );
}

function AboutInfo({ label, value }) {
  return (
    <div className="flex items-center gap-3 text-xs [&>span:first-child]:rounded-md [&>span:first-child]:bg-portfolio-accent [&>span:first-child]:px-2 [&>span:first-child]:py-1 [&>span:first-child]:text-portfolio-inverse">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}
